<template>
	<div class="card-link" v-if="shouldShowCard">
		<CardSlashed>
			<template #left>
				<div class="choose-container">
					<h2>{{ getString("choose_qromo_link") }}</h2>
					<p class=" mt-10">{{ getString("choose_link_warning_1") }}</p>
					<p class="border-top-divider mt-10">{{ getString("choose_link_warning_2") }}</p>
					<div class="action-link-container">
						<div class="wrapper-input-link">
							<AppTextInput ref="link-input" :placeholder="getString('example_link')" :label="getString('link')" />
							<p>{{ "."+HOST }}</p>
						</div>
						<AppButton outline inverted :text="getString('publish')" @click="saveLink" />
					</div>
				</div>
			</template>
			<template #right>
				<div class="wrapper-img">
					<picture>
						<source type="image/webp" srcset="https://img.qromo.io/img/banner-link-business-new.webp">
						<img src="https://img.qromo.io/img/banner-link-business-new.png" alt="product image">
					</picture>
				</div>
			</template>
		</CardSlashed>
		<AppPopup ref="popup-link-warn" :title="getString('warning')" :body-text="warningMessage" :buttons="[{text: getString('cancel'), negative: true}, {text: getString('continue'), callback: confirmLink}]" />
	</div>
</template>

<script>
import CardSlashed from "@/console-new/components/shared/CardSlashed.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppPopup from "@/shared/components/AppPopup.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		const notificationStore = useNotificationStore();
		return {getString: languageStore.getString, showNotification: notificationStore.showNotification, userStore, HOST: HOST}
	},
	name: "CardSlashedMenuLink",
	emits: ['link-saved'],
	props: {
		forceShow: {
			type: Boolean,
			default: false
		}
	},
	components: {
		CardSlashed,
		AppButton,
		AppTextInput,
		AppPopup
	},
	data() {
		return {
			pendingLink: ''
		}
	},
	computed: {
		hasLink() {
			return this.userStore.currBusiness && (this.userStore.currBusiness.link != null && this.userStore.currBusiness.link.length > 0);
		},
		shouldShowCard() {
			// If forceShow is true (used in bottom sheet), always show
			if (this.forceShow) {
				return true;
			}
			// Otherwise, only show if business exists and has no link
			return this.userStore.currBusiness ? !this.hasLink : false;
		},
		warningMessage() {
			if (this.pendingLink) {
				return this.getString('warning_link_confirm', [`https://${this.pendingLink}.${HOST}`]);
			}
			return this.getString('warning_link');
		}
	},
	methods: {
		saveLink() {
			let link = this.$refs["link-input"].currentValue.toLowerCase();
			if(link.length > 2 && link.match(/^[a-z0-9]+$/i) !== null) {
				this.pendingLink = link;
				this.$refs['popup-link-warn'].toggleStatus(true);
			} else {
				this.showNotification("link-invalid");
			}
		},
		confirmLink() {
			let linkInput = this.$refs["link-input"];
			let link = this.pendingLink;
			let self = this;
			this.userStore.createLinkBusiness(link,function (success, details) {
				self.$refs['popup-link-warn'].toggleStatus(false);
				self.pendingLink = ''; // Reset pending link
				if (success) {
					self.showNotification("generic-success");
					if(linkInput?.$refs?.input?.value) {
						linkInput.$refs.input.value = "";
					}
					self.$emit('link-saved');
				} else if(details === "already_exists") {
					self.showNotification("link-already-exists");
				} else if(details === "not_editable") {
					self.showNotification("link-not-editable");
				} else {
					self.showNotification("generic-fail");
				}
			});
		}
	}
}
</script>

<style lang="scss" scoped>
.card-link {
	:deep(.card-container) {
		.card-body {
			padding: 0;
			.slashed-card-container {
				padding: 20px;
				background: linear-gradient(198deg, var(--color-danger) 0%, var(--color-primary) 60%);
				gap: 20px;
				@media (max-width: 550px) {
					flex-direction: column-reverse;
					padding: 20px;
					gap: 20px;
				}
				.slashed-left {
					padding: 0;
					width: 60%;
					overflow: unset;
					@media (max-width: 550px) {
						width: 100%;
					}
				}
				.slashed-right {
					padding: 0;
					width: 40%;
					@media (max-width: 550px) {
						width: 100%;
					}
				}
			}
			h2, p, label {
				color: var(--color-txt-white);
			}
		}
	}

	.card-link-title {
		color: var(--color-txt-white);
		display: flex;
		align-items: center;
		justify-content: center;
		max-width: 400px;
		padding: 0 15px;
		text-align: center;

		h2 {
			font-size: 24px;
			@media (max-width: 500px) {
				font-size: 20px;
			}
		}
	}

	.choose-container {
		width: 100%;

		.warn-link {
			color: $danger;
			font-size: 14px;

		}

		.action-link-container {
			display: flex;
			align-items: flex-end;
			justify-content: space-between;
			margin-top: 20px;
			margin-bottom: 10px;
			gap: 20px;

			.input-wrapper {
				width: 100%;
				max-width: 280px;
			}

			.wrapper-input-link {
				display: flex;
				align-items: flex-end;
				gap: 10px;
				width:  100%;
			}

			@media (max-width: 768px) {
				flex-direction: column;
				align-items: flex-start;

				.input-wrapper {
					margin-right: 0;
					margin-left: 0;
				}
			}

		}
	}
}

.border-top-divider {
	border-top: 1px solid rgba(255, 255, 255, 0.4);
	padding-top: 10px;
	margin-top: 10px;
}

.wrapper-img {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	picture {
		img {
			width: 100%;
			height: 100%;
			max-height: 220px;
			object-fit: contain;
			filter: invert(1);
			@media (max-width: 550px) {
				max-height: 230px;
			}
		}
	}
}

.dark {
	.card-link {
		:deep(.card-container) {
			.card-body {
				.slashed-card-container {
					background: linear-gradient(198deg, var(--color-secondary) 0%, #0567d0 60%);
				}
			}
		}
	}
	.wrapper-img {
		picture {
			img {
				filter: unset;
			}
		}
	}
}

.base-button {
	min-width: 120px;
}
</style>